import React from 'react';
import { classNames } from '../../utils/style';
import { Illustration } from './Illustration';
import { IllustrationName, illustrationsLibrary } from './illustrationLibrary';
import { getColor } from './logic';
import { PictoComponent } from './PictoComponent';
import { PictoName, pictosLibrary } from './pictosLibrary';

interface IconProps {
  className?: string;
  name: IllustrationName | PictoName;
  variant?: 'light' | 'dark' | 'white';
  url?: string;
  loading?: 'lazy' | 'eager';
  width?: number;
  height?: number;
  twTextColor?: string;
  style?: React.CSSProperties;
}

export const Icon = ({
  className,
  name,
  variant,
  loading = 'lazy',
  twTextColor,
  style,
}: IconProps) => {
  const color = getColor(variant);
  const isPicto = pictosLibrary.includes(name as PictoName);
  const isIllustration = illustrationsLibrary.includes(
    name as IllustrationName,
  );

  return (
    <>
      {isPicto && (
        <PictoComponent
          name={name as PictoName}
          className={classNames(className, !twTextColor ? color : twTextColor)}
          style={style}
        />
      )}

      {isIllustration && (
        <Illustration
          name={name as IllustrationName}
          className={className}
          loading={loading}
          style={style}
        />
      )}
    </>
  );
};
